(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-main"]) return;
  try {
    
  (function() {

    /* ── Remove item ── */
    document.querySelectorAll('.cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.dataset.key;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function() { window.location.reload(); });
      });
    });

    /* ── Quantity change ── */
    document.querySelectorAll('.quantity-selector__btn[data-key]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.dataset.key;
        var input = document.querySelector('.quantity-selector__input[data-key="' + key + '"]');
        var current = parseInt(input.value, 10) || 1;
        var newQty = this.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
        input.value = newQty;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        }).then(function() { window.location.reload(); });
      });
    });

    /* ── Discount / voucher code ── */
    var applyBtn = document.getElementById('apply-discount');
    var discountInput = document.getElementById('discount-code');
    var discountMsg = document.getElementById('discount-msg');

    if (applyBtn && discountInput) {
      applyBtn.addEventListener('click', function() {
        var code = discountInput.value.trim();
        if (!code) {
          discountMsg.textContent = 'Please enter a voucher code.';
          discountMsg.className = 'cart-summary__voucher-msg is-error';
          return;
        }

        applyBtn.textContent = 'Applying...';
        applyBtn.disabled = true;
        discountMsg.textContent = '';
        discountMsg.className = 'cart-summary__voucher-msg';

        /* Apply via Shopify discount endpoint then redirect to checkout */
        fetch('/discount/' + encodeURIComponent(code), {
          method: 'GET',
          redirect: 'follow'
        }).then(function(response) {
          if (response.ok || response.redirected) {
            discountMsg.textContent = 'Code applied! Redirecting to checkout...';
            discountMsg.className = 'cart-summary__voucher-msg is-success';
            setTimeout(function() {
              window.location.href = '/checkout?discount=' + encodeURIComponent(code);
            }, 800);
          } else {
            discountMsg.textContent = 'That code doesn\'t seem to be valid. Please check and try again.';
            discountMsg.className = 'cart-summary__voucher-msg is-error';
            applyBtn.textContent = 'Apply';
            applyBtn.disabled = false;
          }
        }).catch(function() {
          /* Fallback: just pass code to checkout URL */
          discountMsg.textContent = 'Code applied! Redirecting to checkout...';
          discountMsg.className = 'cart-summary__voucher-msg is-success';
          setTimeout(function() {
            window.location.href = '/checkout?discount=' + encodeURIComponent(code);
          }, 800);
        });
      });

      /* Allow pressing Enter in discount field */
      discountInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyBtn.click();
        }
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const toggle = document.querySelector('.header__menu-toggle');
    const nav = document.getElementById('mobile-nav');
    const overlay = document.querySelector('.mobile-nav__overlay');
    const closeBtn = document.querySelector('.mobile-nav__close');

    function openNav() {
      nav.classList.add('is-open');
      nav.removeAttribute('aria-hidden');
      overlay.classList.add('is-visible');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-visible');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (toggle) toggle.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (overlay) overlay.addEventListener('click', closeNav);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
    });

    /* ── In-header search: results appear under the header as you type ── */
    const searchToggle = document.querySelector('.header__search-toggle');
    const searchPanel = document.getElementById('header-search');

    if (searchToggle && searchPanel) {
      const input = searchPanel.querySelector('.header-search__input');
      const closeSearchBtn = searchPanel.querySelector('.header-search__close');
      const results = document.getElementById('header-search-results');
      const defaultList = document.getElementById('header-search-default');
      const headerEl = document.getElementById('header');
      const suggestUrl = searchPanel.dataset.suggestUrl;
      const priceFormat = new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {
        style: 'currency',
        currency: searchPanel.dataset.currency || 'EUR'
      });
      let debounceTimer;
      let controller;
      let activeIndex = -1;
      let isOpen = false;
      let hideTimer;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
      }

      function setResultsOpen(open) {
        results.hidden = !open;
        input.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      function showDefault() {
        activeIndex = -1;
        if (!defaultList || !defaultList.content.querySelector('.header-search__item')) {
          results.innerHTML = '';
          setResultsOpen(false);
          return;
        }
        results.innerHTML = '';
        results.appendChild(defaultList.content.cloneNode(true));
        setResultsOpen(true);
      }

      function openSearch() {
        isOpen = true;
        clearTimeout(hideTimer);
        searchPanel.hidden = false;
        void searchPanel.offsetWidth; // let the closed state paint so the bar can grow from the icon
        searchPanel.classList.add('is-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        if (headerEl) headerEl.classList.add('header--searching');
        input.focus({ preventScroll: true });
        showDefault();
      }

      function closeSearch(restoreFocus) {
        if (!isOpen) return;
        isOpen = false;
        searchPanel.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        if (headerEl) headerEl.classList.remove('header--searching');
        if (restoreFocus !== false) searchToggle.focus();
        // wait for the bar to shrink back into the icon before hiding it
        hideTimer = setTimeout(function() {
          searchPanel.hidden = true;
          setResultsOpen(false);
          input.value = '';
          results.innerHTML = '';
          activeIndex = -1;
        }, reduceMotion.matches ? 0 : 350);
      }

      function items() {
        return Array.from(results.querySelectorAll('.header-search__item'));
      }

      function highlight(index) {
        const list = items();
        list.forEach(function(el, i) { el.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
        activeIndex = index;
        if (list[index]) {
          list[index].scrollIntoView({ block: 'nearest' });
          input.setAttribute('aria-activedescendant', list[index].id);
        } else {
          input.removeAttribute('aria-activedescendant');
        }
      }

      function showMessage(text) {
        results.innerHTML = '<p class="header-search__message">' + text + '</p>';
        setResultsOpen(true);
      }

      function render(products, term) {
        activeIndex = -1;
        if (!products.length) {
          showMessage('No leggings found for “' + escapeHtml(term) + '”.');
          return;
        }
        results.innerHTML = '<ul class="header-search__list" role="presentation">' + products.map(function(p, i) {
          const image = p.featured_image && p.featured_image.url
            ? '<img class="header-search__thumb" src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">'
            : '<span class="header-search__thumb"></span>';
          const price = p.price ? priceFormat.format(parseFloat(p.price)) : '';
          return '<li role="presentation"><a class="header-search__item" id="header-search-option-' + i + '" role="option" aria-selected="false" href="' + p.url + '">' +
            image +
            '<span><span class="header-search__title">' + escapeHtml(p.title) + '</span>' +
            '<span class="header-search__price">' + price + '</span></span></a></li>';
        }).join('') + '</ul>';
        setResultsOpen(true);
      }

      function search(term) {
        if (controller) controller.abort();
        controller = new AbortController();
        const url = suggestUrl + '?q=' + encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller.signal })
          .then(function(res) { return res.json(); })
          .then(function(data) {
            const products = (data.resources && data.resources.results && data.resources.results.products) || [];
            render(products, term);
          })
          .catch(function(err) {
            if (err.name !== 'AbortError') showMessage('Search isn’t available right now. Please try again.');
          });
      }

      searchToggle.addEventListener('click', function() {
        if (isOpen) closeSearch(); else openSearch();
      });
      closeSearchBtn.addEventListener('click', closeSearch);
      input.addEventListener('focus', function() {
        if (input.value.trim().length < 2) showDefault();
      });

      input.addEventListener('input', function() {
        const term = input.value.trim();
        clearTimeout(debounceTimer);
        if (term.length < 2) {
          if (controller) controller.abort();
          showDefault();
          return;
        }
        debounceTimer = setTimeout(function() { search(term); }, 200);
      });

      input.addEventListener('keydown', function(e) {
        const list = items();
        if (e.key === 'ArrowDown' && list.length) {
          e.preventDefault();
          highlight((activeIndex + 1) % list.length);
        } else if (e.key === 'ArrowUp' && list.length) {
          e.preventDefault();
          highlight(activeIndex <= 0 ? list.length - 1 : activeIndex - 1);
        } else if (e.key === 'Enter') {
          // Stay in the header: open the highlighted (or first) product instead of a search page
          e.preventDefault();
          const target = list[activeIndex] || list[0];
          if (target) window.location.href = target.href;
        } else if (e.key === 'Escape') {
          closeSearch();
        }
      });

      document.addEventListener('click', function(e) {
        if (isOpen && !searchPanel.contains(e.target) && !searchToggle.contains(e.target)) {
          closeSearch(false);
        }
      });
    }

    const header = document.getElementById('header');
    if (header) {
      const spacer = document.createElement('div');
      header.parentNode.insertBefore(spacer, header.nextSibling);

      function updateSticky() {
        if (window.scrollY > 0) {
          if (!header.classList.contains('header--fixed')) {
            spacer.style.height = header.offsetHeight + 'px';
            header.classList.add('header--fixed');
          }
        } else {
          header.classList.remove('header--fixed');
          spacer.style.height = '0px';
        }
      }

      window.addEventListener('scroll', updateSticky, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
  (function() {
    var gallery = document.getElementById('product-gallery-main');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.product-gallery__thumb'));
    var slides = Array.prototype.slice.call(document.querySelectorAll('.product-gallery__slide'));
    var prevBtn = document.getElementById('gallery-prev');
    var nextBtn = document.getElementById('gallery-next');
    var activeSet = gallery ? gallery.dataset.activeSet : null;
    var colorSet = gallery ? gallery.dataset.colorSet : null;
    var currentIndex = 0;

    function inActiveSet(el) {
      return !activeSet || !el.dataset.set || el.dataset.set === activeSet;
    }

    function activeSlides() {
      return slides.filter(inActiveSet);
    }

    function showSlide(index) {
      currentIndex = index;
      var setSlides = activeSlides();
      var setThumbs = thumbs.filter(inActiveSet);
      slides.forEach(function(s) { s.classList.remove('is-active'); });
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      if (setSlides[index]) setSlides[index].classList.add('is-active');
      if (setThumbs[index]) setThumbs[index].classList.add('is-active');
    }

    function updateGalleryForColor(color) {
      if (!colorSet || !color) return;
      var nextSet = color.trim().toLowerCase() === colorSet ? 'color' : 'default';
      if (nextSet === activeSet) return;
      activeSet = nextSet;
      thumbs.forEach(function(t) { t.hidden = !inActiveSet(t); });
      var hideArrows = activeSlides().length < 2;
      if (prevBtn) prevBtn.hidden = hideArrows;
      if (nextBtn) nextBtn.hidden = hideArrows;
      showSlide(0);
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        showSlide(parseInt(this.dataset.index, 10));
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        var count = activeSlides().length;
        showSlide((currentIndex - 1 + count) % count);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        var count = activeSlides().length;
        showSlide((currentIndex + 1) % count);
      });
    }

    var waitlistForm = document.getElementById('product-waitlist');
    var waitlistTags = document.getElementById('waitlist-tags');
    if (waitlistForm && waitlistTags) {
      var baseTags = waitlistTags.value;
      waitlistForm.addEventListener('submit', function() {
        var extra = [];
        var size = document.querySelector('#size-pills .size-pill.is-selected');
        var colour = document.querySelector('#color-swatches .product-option__swatch.is-selected');
        if (size) extra.push('waitlist-size-' + size.getAttribute('data-size'));
        if (colour) extra.push('waitlist-colour-' + colour.getAttribute('data-color'));
        waitlistTags.value = [baseTags].concat(extra).join(',');
      });
    }

    var sizePills = document.querySelectorAll('#size-pills .size-pill');
    var sizeLabel = document.getElementById('size-selected');
    sizePills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        sizePills.forEach(function(p) { p.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        if (sizeLabel) sizeLabel.textContent = this.getAttribute('data-size');
      });
    });

    var colorSwatches = document.querySelectorAll('#color-swatches .product-option__swatch');
    var colorLabel = document.getElementById('color-selected');
    colorSwatches.forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        colorSwatches.forEach(function(s) { s.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        if (colorLabel) colorLabel.textContent = this.getAttribute('data-color');
        updateGalleryForColor(this.getAttribute('data-color'));
      });
    });

    var optionPills = document.querySelectorAll('.product-option__pill, .product-option__swatch');
    optionPills.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = this.closest('[data-option-index]');
        group.querySelectorAll('.product-option__pill, .product-option__swatch').forEach(function(b) {
          b.classList.remove('is-selected');
        });
        this.classList.add('is-selected');
        var optionIndex = parseInt(group.dataset.optionIndex, 10);
        var selectedLabel = document.getElementById('option-selected-' + optionIndex);
        if (selectedLabel) selectedLabel.textContent = this.dataset.value;
        if (this.classList.contains('product-option__swatch')) updateGalleryForColor(this.dataset.value);
      });
    });

    var qtyInput = document.querySelector('.quantity-selector__input');
    document.querySelectorAll('.quantity-selector__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var current = parseInt(qtyInput.value, 10) || 1;
        if (this.dataset.action === 'increase') {
          qtyInput.value = current + 1;
        } else if (this.dataset.action === 'decrease' && current > 1) {
          qtyInput.value = current - 1;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
